import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { isOnPath } from '../../store/apiWrapper';
import { getScrollY } from '../../store/almightyElementWrapper';
import { layoutActions } from '../../store/layoutStore';
import { reportNavActions } from '../../store/reportNavStore';
import { userContextActions } from '../../store/userContextStore';
import { isNullOrUndefined, isRepiWeb } from '../../store/storeFunctions';
import Footer from '../layoutItems/footer';
import Message from '../common/message';
import NavMenu from '../layoutItems/navMenu';
import TopPanel from '../layoutItems/topPanel';
import RightPanel from '../layoutItems/rightPanel';
import ToTopButton from '../common/toTopButton';
import MobileDockerMenu from '../layoutItems/mobileDockerMenu';
import SettingsDockerMenu from '../settings/settingsComponent';

import '../layoutItems/layout.scss';
import './privateLayoutNew.scss'

class RepiLayout extends React.Component {
    state = {
        scrollTop: 0,
        isOnReport: false,
        isBegin: true,
        isEnd: false,
        minusWidth: 0,
        hasScrollY: false
    }

    componentDidMount() {
        if (localStorage.locales_report_width === "full")
            document.body.classList.add("full-report-width");
        else
            document.body.classList.remove("full-report-width");

        if (isRepiWeb()) {
            document.body.classList.remove("lp-minimized");
            document.body.classList.remove("lp-fixed");
            document.body.classList.add("lp-hide");
        }
    }

    UNSAFE_componentWillMount() {
        const that = this; // because of setInterval stupidity
        this.updaterInterval = window.setInterval(function() {that.updateScrollbar();}, 500);
    }

    componentWillUnmount() {
        window.clearInterval(this.updaterInterval);
    }

    updateScrollbar = () => {
        const newY = getScrollY();
        if(this.state.scrollTop !== newY) {
            this.setState({scrollTop: newY});
        }
    }

    componentDidUpdate(_, prevState) {
        const isOnReport = isOnPath({ regex: /report/i });
        if(isOnReport != prevState.isOnReport) {
            this.setState({isOnReport});
        }
    }

    render() {
        const tint = localStorage.locales_tint;
        return (
            <div className="grid-root">
                <div className={classnames("main-content", { "scrolled-y": this.state.scrollTop > 0 })}
                    style={{ marginRight: this.state.minusWidth, paddingTop: this.props.user.authentication.limitedUser ? "0px" : null }}>
                    { !this.props.user.authentication.limitedUser && <div className="page-nav print-hidden">
                        <NavMenu componentProps={this.props.componentProps} mobileTinted={tint === "header"} />
                    </div> }
                    {this.renderScrollingContent(tint)}
                </div>
                <RightPanel tinted={tint === 'menu'} onWidthChange={(w, _) => this.resizeMain(w)} />
                <MobileDockerMenu />
                <SettingsDockerMenu scrollWidth={document.documentElement.clientWidth}/>
            </div>
        );
    }

    resizeMain = (minusWidth) => {
        if(minusWidth !== null && this.state.minusWidth !== minusWidth) {
            this.setState({minusWidth});
        }
    }

    renderError = () => {
        return (
            <div className="error-container error-container-wide" style={{padding:"1em"}}>
                <Message type={"warning"} options={{ renderInnerHtml: true }}
                    message={this.props.translate(this.props.error, isNullOrUndefined(this.props.errorData) ? undefined : this.props.errorData)} />
            </div>
        );
    }

    renderScrollingContent = (tint) => {
        const Component = this.props.component;
        return (
            <div className={classnames("content-body-wrapper", { "content-mobile-search": this.props.layout.topMenuExpanded })}>
                <TopPanel {...{ ...this.props.componentProps, tinted: tint === "header", right: this.state.minusWidth }} />
                <div className={`content-body ${this.props.pageClass || ""}`}>
                    <div className="page-content">
                        {this.props.error && this.renderError()}
                        <Component {...this.props.componentProps} {...this.props.children}></Component>
                    </div>
                    <div className="page-footer">
                        <ToTopButton scrollTop={this.state.scrollTop} isBegin={this.state.isBegin} isEnd={this.state.isEnd} right={this.state.minusWidth} />
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }

    getDisplaySettings(setting, defaultVal) {
        try {
            return this.props.user.authentication.profile.displaySettings[setting]
        } catch {
            return defaultVal;
        }
    }
}

export default withLocalize(connect(
    state => ({ ...state.appContext, nav: state.reportNav, user: state.userContext, layout: state.layout }),
    dispatch => bindActionCreators({ ...layoutActions, ...userContextActions, ...reportNavActions }, dispatch)
)(withRouter(RepiLayout)));